import React from "react";
import { Card, CardContent, Typography, Grid, Box } from "@mui/material";
import { styled } from "@mui/system";
import { CustomChartsTitle } from "./CustomTypography";
import { UNIT_TYPE } from "../../globals/utils";

const StyledCard = styled(Card)({
  border: "1px solid #A5A5A5",
  borderRadius: "8px",
  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  maxWidth: "100%",
  margin: "0",
  height: "100%",
});

const StyledCardContent = styled(CardContent)({
  paddingBottom: "8px !important",
});

const AreaDisplay = ({ data, unit }) => (
  <Grid item xs={12}>
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        paddingTop: "0px",
        paddingBottom: "0px",
      }}
    >
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: "22px",
          textAlign: "center",
          marginBottom: "0px",
          marginRight: "8px",
          color: "#333",
        }}
      >
        {data} {unit?.split("(")[0]?.trim()}
      </Typography>
      <Typography
        sx={{
          fontWeight: 500,
          fontSize: "14px",
          textAlign: "center",
          color: "#514F4F",
        }}
      >
        ({unit?.split("(")[1] || ""}
      </Typography>
    </Box>
  </Grid>
);

const RegularDisplay = ({ data, unit }) => (
  <Grid item xs={6}>
    <Box style={{ display: "flex", alignItems: "center" }}>
      <Typography
        style={{
          fontWeight: 700,
          fontSize: "22px",
          textAlign: "left",
          marginRight: "8px",
        }}
      >
        {data}
      </Typography>
      <Typography
        style={{ fontWeight: 500, fontSize: "14px", textAlign: "left" }}
      >
        {unit}
      </Typography>
    </Box>
  </Grid>
);

const ObjectDataDisplay = ({ data, unit }) =>
  Object.entries(data).map(([label, value], index) => (
    <Grid item xs={6} key={index}>
      <Box style={{ display: "flex", flexDirection: "column" }}>
        <Typography
          style={{
            fontWeight: 500,
            fontSize: "14px",
            textAlign: "left",
            color: "#514F4F",
          }}
        >
          {label}:
        </Typography>
        <Typography
          style={{
            fontWeight: 700,
            fontSize: "22px",
            textAlign: "left",
            marginTop: "4px",
          }}
        >
          {value} {unit}
        </Typography>
      </Box>
    </Grid>
  ));

const renderDataGrid = (data, unit) => {
  // Check if data is an object first
  if (typeof data === "object" && data !== null) {
    return <ObjectDataDisplay data={data} unit={unit} />;
  }
  const isHectareUnit =
    typeof unit === "string" && unit.includes(UNIT_TYPE.HECTARES);

  return isHectareUnit ? (
    <AreaDisplay data={data} unit={unit} />
  ) : (
    <RegularDisplay data={data} unit={unit} />
  );
};

const CustomDashboardCard = ({ title, data, buttons, month, unit }) => {
  return (
    <StyledCard>
      <StyledCardContent>
        <CustomChartsTitle>{title}</CustomChartsTitle>
        <Grid container sx={{ marginTop: "10px" }}>
          {renderDataGrid(data, unit)}
          {buttons && (
            <>
              <Grid item xs={6}>
                <div
                  style={{
                    borderRadius: "10px",
                    background: "#4CAF50",
                    color: "white",
                    width: "60px",
                    textAlign: "center",
                    marginTop: "4px",
                    padding: "3px",
                  }}
                  onClick={buttons.onClick}
                >
                  {buttons.label}
                </div>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  style={{
                    fontSize: "10px",
                    fontWeight: 400,
                    color: "#514F4F",
                  }}
                >
                  {month.label}:
                </Typography>
                <Typography
                  style={{
                    fontSize: "10px",
                    fontWeight: 400,
                    color: "#514F4F",
                  }}
                >
                  {month.data}
                </Typography>
              </Grid>
            </>
          )}
        </Grid>
      </StyledCardContent>
    </StyledCard>
  );
};
export default CustomDashboardCard;
